<template>
  <zm-dialog
    v-model="visible"
    :title="title"
    width="500px"
    append-to-body
  >
    <p>{{ alertContent }}</p>
    <template #footer>
    <div>
      <zm-button data-testid="checkout-button-37" type="primary" @click="handleSwitch">{{ continueBtnLabel }}</zm-button>
      <zm-button data-testid="checkout-button-38" @click="handleCancel">{{ $t('billing.common.cancel') }}</zm-button>
    </div>
    </template>
  </zm-dialog>
</template>

<script>
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import { mapState, mapGetters } from 'vuex';
import { ZOOM_MEETING_SUB_TYPES } from '@/plans/ZOOM_MEETING/common/utils';
import Migration from '@/plans/ZOOM_MEETING/dialog/mixins/migration';
import { translateToEn } from '@/plugins/i18n';

export default {
  mixins: [ConfirmComponent, Migration],
  props: {
    sourcePlan: {
      type: Object,
      required: true,
    },
    targetPlan: {
      type: Object,
      required: true,
    },
    currentLicense:{
      type: Number,
      required: false,
    }
  },
  data () {
    return {
      visible: false,
      MRSResult: null,
      appList: [],
    };
  },
  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
      allPlanMap: state => state.ShoppingCart.allPlanMap
    }),
    ...mapGetters([
      'getCurrentBasePlanInfo',
      'limitLicenseWithBaseZoneTypes',
    ]),
    title () {
      const maxHosts = this.sourcePlan?.maxHosts ?? 9;
      const limitHosts = maxHosts + 1
      return this.$t('billing.need_more_license',[limitHosts]);
    },
    continueBtnLabel () {
      return  this.$t('billing.switch_to',[this.$t('common.business')])
    },
    alertContent () {
      if(!this.sourcePlan || !this.targetPlan) return null
      const { maxHosts, planNameKey: sourcePlanNameKey } = this.sourcePlan
      const { planNameKey } = this.targetPlan
      return this.$t('billing.need_more_license_desc',[this.$t(sourcePlanNameKey),
      maxHosts,
      maxHosts,
      this.$t(planNameKey),
      this.$t('billing.planform.title.zoom_one_biz')]);
    },
    trackingPlanName() {
      return translateToEn(this.targetPlan?.planNameKey);
    },
    trackingTitle() {
      return translateToEn('billing.need_more_license', [(this.sourcePlan?.maxHosts ?? 9) + 1]);
    }
  },
  methods: {
    handleSwitch(){
      this.switchMeetingPlanCategory({ category: ZOOM_MEETING_SUB_TYPES.BIZ, targetLicenses: this.currentLicense })
      this.$tracking.buyInteraction(`${this.trackingPlanName} plan license`, `${this.trackingTitle} - switch to business plan`)
    },
    handleOpen() {
      this.$tracking.buyInteraction(`${this.trackingPlanName} plan license`, `${this.trackingTitle} - impression`);
    },
    handleCancel() {
      this.$tracking.buyInteraction(`${this.trackingPlanName} plan license`, `${this.trackingTitle} - cancel`)
    }
  },
};
</script>

<style lang="scss" scoped>
@use "sass:math";
$app-icon-size: 60px;
$dialog-width: 980px;
.essential-dialog-header {
  padding: 0 100px 20px 100px;
  margin-bottom: 30px;
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #fff;
  .dialog-title {
    color: #0E72ED;
    font-size: 32px;
    text-align: center;
    margin-bottom: 10px;
  }
  .dialog-subtext {
    color: #000;
    text-align: center;
    font-size: 16px;
  }
  & > button {
    margin: 0 auto;
    padding: 0;
    display: none;
  }
}
.essential-dialog-body {
  .app-category-list {
    list-style: none;
    padding: 0;
    & > li {
      &:not(:last-child) {
        margin-bottom: 40px;
      }
      .category-title {
        font-size: 24px;
        color:#000000;
        font-weight: 400;
        text-align: center;
        margin-bottom: 30px;
      }
    }
    .app-item-list {
      $column-gap: 30px;
      list-style: none;
      display: grid;
      padding: 0;
      grid-template-columns: repeat(2, calc(50% - #{math.div($column-gap, 2)}));
      column-gap: $column-gap;
      & > li {
        border-radius: 6px;
        margin-bottom: 10px;
        &:hover {
          background-color: #f6f6f6;
        }
        .app-card {
          padding: 10px;
          display: grid;
          grid-template-columns: ($app-icon-size + 12px) auto auto;
          grid-template-rows: auto-fill auto;
          grid-template-areas: 'icon info' 'icon desc';
          p {
            margin: 0;
          }
          .app-icon {
            flex: 0 0 $app-icon-size;
            height: $app-icon-size;
            width: $app-icon-size;
            border-radius: 12px;
            margin-right: 12px;
            grid-area: icon;
            & > img {
              width: $app-icon-size;
              height: $app-icon-size;
            }
          }
          .app-info {
            grid-area: info;
            display: flex;
            align-items: baseline;
            .app-name {
              font-size: 16px;
              color: #000;
              font-weight: 600;
            }
            .app-author {
              font-size: 14px;
              color: #515079;
              font-weight: 500;
              min-width: 80px;
              margin-left: 6px;
            }
          }
          .app-desc {
            font-size: 12px;
            color: #000000;
            font-weight: 500;
            word-break: break-word;
            grid-area: desc;
          }
        }
      }
    }
  }
}
.essential-dialog-footer {
  margin: 40px 0 20px 0;
  text-align: center;
  button {
    display: inline-block;
    color: #0B5CFF;
    font-weight: 600;
    font-size: 16px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
.essential-dialog-legal {
  font-size: 12px;
  color: #515079;
  font-weight: 600;
  line-height: 1.42;
}
</style>
<style lang="scss">

</style>
